import { message } from "antd";
import { mapColumnCategory } from "../utils/utils";

import {
  fetchPlan,
  fetchPlanInfo,
  exportPlan,
  getExportPlanStatus,
  cancelExportPlan,
  updatePlanName,
  updatePlanLimit,
  pauseAdPlan,
  serveAdPlan,
  removeAdPlan,
  updatePlanServingMode,
  fetchAd,
  fetchAdDetail,
  exportAd,
  getExportAdStatus,
  cancelExportAd,
  updateAdName,
  updateAdPrice,
  removeAd,
  pauseAdform,
  serveAdform,
  editDayLimit,
  fetchCreativity,
  exportCreativity,
  getExportCreativityStatus,
  cancelExportCreativity,
  pauseAdCreativity,
  serveAdCreativity,
  removeAdCreativity,
  editClickMonitorLink,
  editExposureMonitorLink,
  queryCustomList,
  editCustomList,
  updateCustomPage,
  getCustomPage,
  updateBatchLimited,
  updateBatchCalendar,
  updateBatchTime,
  getCampaignPackage,
  getCampaignPackageOfPosition,
  removePlanBatch,
  pausePlanBatch,
  servePlanBatch,
  updateBatchTargetingContent,
  updateBatchBudget,
  fetchHomeStat,
  getEffectTouch,
  getPositionAdvisedPrice,
  editActiveMonitorLink,
  editPlayMonitorLink,
  checkAdCountLimit,
} from "../services/api";

const operatePlan = {
  updatePlanName,
  updatePlanLimit,
  updatePlanServingMode,
  pauseAdPlan,
  serveAdPlan,
  removeAdPlan,
};
const operatePlanBath = {
  removePlanBatch,
  pausePlanBatch,
  servePlanBatch,
}

const operatePlanText = {
  updatePlanName: "名称编辑",
  updatePlanLimit: "限额编辑",
  updatePlanServingMode: "投放方式切换",
  pauseAdPlan: "暂停",
  serveAdPlan: "启用",
  removeAdPlan: "删除",
  removePlanBatch: "删除",
  pausePlanBatch: "暂停",
  servePlanBatch: "启用",
};

const adContant = {
  getCampaignPackage, getCampaignPackageOfPosition,
}

const operateAd = {
  updateAdName,
  updateAdPrice,
  updateAdPriceByPercent: updateAdPrice,
  pauseAdform,
  serveAdform,
  editDayLimit,
  removeAd,
  updateBatchLimited,
  updateBatchCalendar,
  updateBatchTime,
};

const operateCreativity = {
  pauseAdCreativity,
  serveAdCreativity,
  removeAdCreativity,
  editClickMonitorLink,
  editActiveMonitorLink,
  editPlayMonitorLink,
  editExposureMonitorLink, // 返回结构不一致
};

const dataExport = {
  exportPlan,
  getExportPlanStatus,
  cancelExportPlan,
  exportAd,
  getExportAdStatus,
  cancelExportAd,
  exportCreativity,
  getExportCreativityStatus,
  cancelExportCreativity,
};

const typeMap = {
  plan: 0,
  ad: 1,
  creativity: 2,
  creativityReport: 3,
  AudiencesReport: 4,
  planBind: 12,
  creativityBind: 14,
  AccountReport: 15,
};

export default {
  namespace: "promote",

  state: {
    planList: {
      dataSource: [],
      total: 0,
      loading: false,
    },

    planInfo: {
      0: {
        data: {},
        loading: false,
      },
    },

    adList: {
      dataSource: [],
      total: 0,
      loading: false,
    },

    adDetail: {
      0: {
        data: {},
        loading: false,
      },
    },

    adOverview: {
      0: {
        data: {},
        loading: false,
      },
    },

    creativityList: {
      dataSource: [],
      total: 0,
      loading: false,
    },

    typeOptionList: [],
    deepLinkAuth: [],

    columnCategory: {
      ad: [],
      plan: [],
      creativity: [],
      creativityReport: [],
      AudiencesReport: [],
      AccountReport: [],
      // 固定列
      planBind: [],
      creativityBind: [],
    },
    selectedColumns: {
      ad: [],
      plan: [],
      creativity: [],
      creativityReport: [],
      AudiencesReport: [],
      AccountReport: [],
      // 固定列
      planBind: [],
      creativityBind: [],
    },
  },

  effects: {
    *checkAdCountLimit(_, { call }) {
      const response = yield call(checkAdCountLimit);
      return response;
    },
    *getAdvisedPrice({ payload, callback }, { call, put }) {
      const response = yield call(getPositionAdvisedPrice, payload);
      return response;
    },
    *queryCustomList({ payload: { type } }, { call, put, all }) {
      const response = yield call(queryCustomList, { type: typeMap[type] });
      if (response && response.listVOS) {
        yield all([
          put({
            type: "updateColumnCategory",
            payload: { list: response.listVOS, type },
          }),
          put({
            type: "updateSelectedColumns",
            payload: { list: response.isCheck, type },
          }),
        ]);
      }
    },
    *saveCustomList({ payload: { type, list } }, { call, put }) {
      const response = yield call(editCustomList, {
        type: typeMap[type],
        first: list.map((item) => parseInt(item, 10)),
      });
      if (response) {
        yield put({
          type: "updateSelectedColumns",
          payload: { type, list },
        });
      }
    },
    *updateCustomPage({ payload }, { call }) {
      yield call(updateCustomPage, { type: payload.type, page: payload.page });
    },
    *getCustomPage({ payload }, { call }) {
      return yield call(getCustomPage, { type: payload.type });
    },
    *getColumnNameSet({ payload: { type } }, { select, put }) {
      let columnCategory = yield select(
        (state) => state.promote.columnCategory[type]
      );
      if (!columnCategory || !columnCategory.length) {
        yield put.resolve({ type: "queryCustomList", payload: { type } }); // https://github.com/dvajs/dva/issues/1212
        columnCategory = yield select(
          (state) => state.promote.columnCategory[type]
        );
      }
      const selectedColumns = yield select(
        (state) => state.promote.selectedColumns[type]
      );
      const columnCodeMap = mapColumnCategory(columnCategory, [
        "code",
        "value",
      ]);
      return new Set(
        (selectedColumns || []).map((code) => columnCodeMap[code])
      );
    },

    *fetchPlan({ payload, callback }, { call, put }) {
      yield put({
        type: "setLoading",
        payload: { type: "plan", loading: true },
      });
      
      const response = yield call(fetchPlan, payload);
      yield put.resolve({ type: "loadPlan", payload: response });

      if (callback) callback();
    },

    *fetchStat({ payload, callback }, { call, put }) {
      yield put.resolve({type: 'totalData', payload: {} });
      const result = yield call(fetchHomeStat, payload);
      // 汇总信息
      yield put.resolve({type: 'totalData', payload: result});
    },

    *fetchPlanInfo({ payload, callback }, { call, put }) {
      // Dashboard 在用?
      const id = payload.adPlanId;
      yield put({
        type: "setLoading",
        payload: { type: "plan", id, loading: true },
      });
      const response = yield call(fetchPlanInfo, payload);
      yield put.resolve({
        type: "loadPlanInfo",
        payload: { data: response, id },
      });
      if (callback) callback();
    },

    *fetchAd({ payload, callback }, { call, put }) {
      yield put({ type: "setLoading", payload: { type: "ad", loading: true } });

      const response = yield call(fetchAd, payload);
      yield put.resolve({ type: "loadAd", payload: response });
      yield put({ type: "loadAdOverview", payload: response });

      if (callback) callback();
    },
    *fetchAdDetail({ payload, callback }, { call, put }) {
      const id = payload.adformId;
      yield put({
        type: "setLoading",
        payload: { type: "ad", id, loading: true, ignore: { list: true } },
      });
      const response = yield call(fetchAdDetail, payload);
      yield put.resolve({
        type: "loadAdDetail",
        payload: { data: response, id },
      });
      if (callback) callback();
    },
    *fetchAdOverview({ payload, callback }, { call, put }) {
      const response = yield call(fetchAd, payload);
      yield put.resolve({ type: "loadAdOverview", payload: response });
      if (callback) callback();
    },

    *fetchCreativity({ payload, callback }, { call, put }) {
      yield put({
        type: "setLoading",
        payload: { type: "creativity", loading: true },
      });
      const response = yield call(fetchCreativity, payload);
      yield put({ type: "loadCreativity", payload: response });
      if (callback) callback();
    },

    *dataExport({ payload, action, callback }, { call }) {
      if (!(action in dataExport)) return;
      const response = yield call(dataExport[action], payload);
      if (callback) callback(response);
      return response;
    },

    *operatePlan({ action, payload, callback }, { call, put }) {
      if (!(action in operatePlan)) return;
      const id = payload.adPlanId;
      yield put({
        type: "setLoading",
        payload: { type: "plan", id, loading: true },
      });
      const response = yield call(operatePlan[action], payload);
      const success = !!response;
      if (!success)
        yield put({
          type: "setLoading",
          payload: { type: "plan", id, loading: false },
        });
      message[success ? "success" : "error"](
        `计划 (${payload.adPlanId}) ${operatePlanText[action]}${
          success ? "成功" : "失败"
        }`
      );
      if (callback) callback();
      return response;
    },

    *operatePlanBath({ action, payload, callback }, { call, put }) {
      if (!(action in operatePlanBath)) return;
      const id = payload.adPlanId;
      yield put({
        type: "setLoading",
        payload: { type: "plan", id, loading: true },
      });
      const response = yield call(operatePlanBath[action], payload);
      const success =
        typeof response === "object"
          ? response && (response.success || []).length
          : response;
      if (!success)
        yield put({
          type: "setLoading",
          payload: { type: "plan", id, loading: false },
        });
      if (callback) callback();
      return response;
    },

    *operateAd({ action, payload, callback }, { call, put }) {
      if (!(action in operateAd)) return;
      const id = payload.adformId;
      yield put({
        type: "setLoading",
        payload: { type: "ad", id, loading: true },
      });
      const response = yield call(operateAd[action], payload);
      const success =
        typeof response === "object"
          ? response && (response.success || []).length
          : response;
      if (!success)
        yield put({
          type: "setLoading",
          payload: { type: "ad", id, loading: false },
        });
      if (callback) callback();
      return response;
    },

    *getAdContant({ action, payload }, { call, put }) {
      const response = yield call(adContant[action], payload)
      yield put({ type: 'setTypeOptionList', payload: response })
    },

    *operateCreativity({ action, payload, callback }, { call, put }) {
      if (!(action in operateCreativity)) return;
      yield put({
        type: "setLoading",
        payload: { type: "creativity", loading: true },
      });
      const response = yield call(operateCreativity[action], payload);
      const success =
        typeof response === "object"
          ? response && (response.success || []).length
          : response;
      if (!success)
        yield put({
          type: "setLoading",
          payload: { type: "creativity", loading: false },
        });
      if (callback) callback();
      return response;
    },

    *updateBatchTargetingContent({payload}, {call}) {
      const response = yield call(updateBatchTargetingContent, payload);
      if (response) {
        message.success('批量修改定向包成功');
      }
      return response;
    },

    *updateBatchBudget({payload}, {call}) {
      const response = yield call(updateBatchBudget, payload);
      if (response) {
        message.success('批量修改日预算成功');
        window.location.reload();
      }
    },
    
    *getEffectTouch({ payload }, {call, put}) {
      const response = yield call(getEffectTouch, payload);
      yield put({ type: "setEffectTouch", payload: response});
    },
  },

  reducers: {
    totalData(state, {payload}) {
      return {
        ...state,
        totalData: payload,
      }
    },
    loadPlan(state, { payload }) {
      const { list, totalCount } = payload || {};
      return {
        ...state,
        planList: {
          dataSource: Array.isArray(list) ? list : [],
          total: totalCount,
          loading: false,
        },
      };
    },
    loadPlanInfo(state, { payload: { data, id } }) {
      return {
        ...state,
        planInfo: {
          ...state.planInfo,
          [id]: {
            ...state.planInfo[id],
            data: data || {},
            loading: false,
          },
        },
      };
    },
    loadAd(state, { payload }) {
      const { list, totalCount } = payload || {};
      return {
        ...state,
        adList: {
          dataSource: Array.isArray(list) ? list : [],
          total: totalCount,
          loading: false,
        },
      };
    },
    loadCreativity(state, { payload }) {
      const { list, totalCount } = payload || {};
      return {
        ...state,
        creativityList: {
          dataSource: (Array.isArray(list) ? list : []).map((item) => ({
            ...item,
            ...item.adCreativeVO,
            adCreativeVO: undefined,
          })),
          total: totalCount,
          loading: false,
        },
      };
    },

    clearAd(state, { payload }) {
      // TODO where use?
      return {
        ...state,
        adList: [],
      };
    },

    loadAdDetail(state, { payload: { id, data } }) {
      return {
        ...state,
        adDetail: {
          ...state.adDetail,
          [id]: {
            ...state.adDetail[id],
            data: data || {},
            loading: false,
          },
        },
      };
    },

    loadAdOverview(state, { payload }) {
      let { list } = payload || {};
      list = Array.isArray(list) ? list : [];

      const update = list.reduce((result, data) => {
        const { adformId } = data || {};
        return adformId
          ? {
              ...result,
              [adformId]: {
                data,
                loading: false,
              },
            }
          : result;
      }, {});

      return {
        ...state,
        adOverview: {
          ...state.adOverview,
          ...update,
        },
      };
    },

    setTypeOptionList(state, { payload }) {
      if(!payload) return
      const { list } = payload
      let typeOptionList =[]
      if(list) {
        typeOptionList = list.map(item => {
          return {
            key: item.uid,
            label: item.name,
            parent: -1,
          }
       })
      }else typeOptionList = payload
      return {
        ...state,
        typeOptionList,
      }
    },

    setLoading(state, { payload: { type, id, loading, ignore = {} } }) {
      const listKey = `${type}List`;
      const infoKey = {
        ad: "adDetail",
        plan: "planInfo",
      }[type];

      const list =
        listKey in state && !ignore.list
          ? {
              [listKey]: {
                ...state[listKey],
                loading,
              },
            }
          : null;

      const info =
        infoKey && infoKey in state && id && !ignore.info
          ? {
              [infoKey]: {
                ...state[infoKey],
                [id]: {
                  ...state[infoKey][id],
                  loading,
                },
              },
            }
          : null;

      return {
        ...state,
        ...list,
        ...info,
      };
    },

    updateColumnCategory(state, { payload: { type, list } }) {
      return {
        ...state,
        columnCategory: {
          ...state.columnCategory,
          [type]: list,
        },
      };
    },

    updateSelectedColumns(state, { payload: { type, list } }) {
      return {
        ...state,
        selectedColumns: {
          ...state.selectedColumns,
          [type]: list,
        },
      };
    },
    
    setEffectTouch(state, {payload}) {
      return {
        ...state,
        effectTouch: payload,
      }
    },
  },
};
